<template>
  <div class="flex flex-col main-container">

    <!-- PROGRESS STEPPER -->
    <div class="flex items-center justify-center gap-6 w-full my-5 lg:my-10">
      <!-- @click="goToStep(step)"  -->
      <div v-for="step in 3" :key="step" class="flex items-center justify-center">
        <div
          class="step-circle w-8 h-8 lg:w-16 lg:h-16 flex items-center justify-center rounded-full text-white font-bold"
          :class="{
            active: currentTab === step,
            completed: currentTab > step
          }">
          {{ step }}
        </div>
      </div>
    </div>

  </div>

  <div ref="tabContainer" class="tab-container p-6 lg:p-12 rounded-2xl mx-5 mb-5 lg: lg:mb-10 lg:mx-10">

    <!-- CONTENT WRAPPER -->
    <div class="flex-1">
      <div
        class="w-full flex flex-col lg:flex-row justify-start items-start lg:items-center gap-2 lg:gap-3 mb-3 xl:text-3xl xl:mb-6">
        <img src="@/assets/images/papsi_back_primary_icon.svg"
          class="w-8 h-8 cursor-pointer hover:bg-gray-200 rounded-full p-1 " @click="goBack()">
        <h1 class="text-primary text-left text-2xl font-semibold">RCBC Account Opening</h1>
      </div>
      <Tab1View ref="tab1" v-if="currentTab === 1" @next="handleNext" @back="handleBack" />
      <Tab2View ref="tab2" v-if="currentTab === 2" @next="handleNext" @back="handleBack" />
      <Tab3View ref="tab3" v-if="currentTab === 3" @submit="submitForm" @back="handleBack" />
    </div>

  </div>


  <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error"
    :success="this.success" :note="this.warning" :question="this.question" z_value="z-50"
    @positiveClick="handlePositiveClick()" :positiveButton="this.positiveText" @negativeClick="handleNegativeClick()"
    :negativeButton="this.negativeText" :default_width="'max-w-xl'" id='vote_modal'>
    <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
      {{ this.modal_message }}
    </div>
  </ModalControl>



</template>

<script>
import User from '@/services/User';
import mixin from '@/mixin';
import ModalControl from '@/components/controls/ModalControl.vue';

import Tab1View from './Tab1View.vue';
import Tab2View from './Tab2View.vue';
import Tab3View from './Tab3View.vue';

export default {
  name: 'v-baseform',
  inject: ['setLoading'],
  mixins: [mixin],
  data() {
    return {
      currentTab: 1,
      show_message_modal: false,
      modal_message: '',
      success: false,
      warning: false,
      error: false,
      question: false,
      positiveText: '',
      negativeText: '',
      expired: false,
    };
  },
  components: {
    Tab1View,
    Tab2View,
    Tab3View,
    ModalControl

  },
  mounted() {
    const state = this.$store.state;

    if (!state.credentials.username) {
      this.getUserInfo();
    } else {
      this.checkUserFlow();
    }
  },
  methods: {
    handlePositiveClick() {
      this.show_message_modal = false;
      if (this.success) {
        this.backToStart();
      }
    },
    handleNegativeClick() {
      this.show_message_modal = false;
      if (this.error) {
        this.backToStart();
      }
    },
    backToStart() {
      this.success_modal = false;
      this.error_modal = false;
      this.$router.push('/bank-account-opening');
      this.$store.state.formDataRCBC = {};
    },
    goBack() {
      this.$router.go(-1);
    },
    goToStep(step) {
      this.currentTab = step;

      this.$nextTick(() => {
        const container = this.$refs.tabContainer;
        if (container?.scrollTo) {
          container.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      });
    },
    handleNext() {
      if (this.currentTab < 3) {
        this.currentTab++;

        this.$nextTick(() => {
          window.scrollTo(0, 0);

          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;

          const c = this.$refs.tabContainer;
        });
      }
    },
    handleBack() {
      if (this.currentTab > 1) {
        this.currentTab--;

        this.$nextTick(() => {
          const container = this.$refs.tabContainer;
          if (container?.scrollTo) {
            container.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        });

      } else {
        this.goBack();
      }
    },
    closed() {
      let that = this;

      that.$cookies.remove('user');
      that.$cookies.remove('user_session');
      that.$router.push('/');
      that.show_message_modal = false;
    },
    submitForm() {
      this.setLoading(true);

      const formData = {
        ...(this.$store.getters.getFormDataRCBC || {}),
        ...(this.$refs.tab1?.form || {}),
        ...(this.$refs.tab2?.form || {}),
        ...(this.$refs.tab3?.form || {}),
      };

      this.$store.commit('setFormDataRCBC', formData);
      User.submitFormRCBC(formData)
        .then(() => {
          this.setLoading(false);
          this.show_message_modal = true;
          this.modal_message = 'Form submitted successfully!';
          this.error = false;
          this.question = false;
          this.success = true;
          this.warning = false;
          this.negativeText = null;
          this.positiveText = 'Okay';
        })
        .catch((error) => {
          this.setLoading(false);
          this.modal_message = error?.response?.data?.message || 'An error occurred';
          this.show_message_modal = true;
          this.error = true;
          this.question = false;
          this.success = false;
          this.warning = false;
          this.negativeText = 'Reset';
          this.positiveText = 'Okay';
        });
    },
    getEndpoints() {
      this.setLoading(true);
      this.$store.state.formDataPNB = {};
      User.getBAOS()
        .then((response) => {
          const data = response.data.data;
          const store = this.$store.state;

          store.lookup = data;
          this.getProvincesLookup();
        })
        .catch((error) => {
          this.setLoading(false);
          this.error_message = error?.response?.data?.message || 'An error occurred';
          this.error_modal = true;
        });
    },
    getProvincesLookup() {
      this.setLoading(true);
      User.getProvinces()
        .then((response) => {
          const data = response.data.data;
          const store = this.$store.state;

          store.provinces = data;
          this.getPSOLookup();
        })
        .catch((error) => {
          this.setLoading(false);
          this.error_message = error?.response?.data?.message || 'An error occurred';
          this.error_modal = true;
        });
    },
    getPSOLookup() {
      this.setLoading(true);
      User.getBranches()
        .then((response) => {
          const data = response.data.data;
          const store = this.$store.state;

          store.pso = data;
          this.setLoading(false);
        })
        .catch((error) => {
          this.setLoading(false);
          this.error_message = error?.response?.data?.message || 'An error occurred';
          this.error_modal = true;
        });
    },
    getUserInfo() {
      let that = this;
      const cookie = that.$cookies;
      const store = that.$store;
      let state = store.state;
      that.setLoading(true);

      User.recoverSession(cookie.get('user_session').hash).then(function (response) {
        let data = response.data.data;
        state.logged = true;
        state.credentials.first_name = data.info.first_name;
        state.credentials.last_name = data.info.last_name;
        state.credentials.middle_name = data.info.middle_name;
        state.credentials.regular = data.info.regular;
        state.credentials.express = data.express;
        state.credentials.pso_enroll = data.pso_enroll;
        state.credentials.pin_update = data.pin_update;
        state.credentials.membership_date = data.info.membership_date || null;
        state.credentials.status = data.status || null;
        state.credentials.account_no = data.info.account_number;
        state.gaUser = data.ga;
        state.credentials.email = data.info.email;
        state.credentials.gender = data.info.gender;
        state.credentials.birthdate = data.info.date_of_birth;
        state.credentials.age = data.info.age;
        state.credentials.membership_type = data.info.membership_type;
        state.credentials.registered_date = data.info.registered;
        state.credentials.key = data.key;
        state.credentials.mobile = data.info.mobile;
        state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
        state.credentials.suffix = data.info.suffix ?? '';
        state.credentials.qr = data.qr;
        state.credentials.uuid = data.uuid;
        state.credentials.serial_no = data.info.serial_number;
        state.credentials.timestamp = response.timestamp;
        state.credentials.username = data.info.username;
        state.credentials.hash = data.hash;
        state.credentials.has_pin = data.has_pin;
        state.credentials.deactivated = data.deactivated;
        state.credentials.tin = data.info.tin;
        state.balances = data.balances;
        const type2Config = data.config.find(item => item.type === 2);
        if (type2Config) {
          state.credentials.config = { status: type2Config.status };
        } else {
          state.credentials.config = null;
        }
        that.account_number = state.credentials.account_no;
        that.full_name = state.credentials.name;
        that.gender = state.credentials.gender;
        that.Astatus = state.credentials.status;
        that.Membership = state.credentials.membership_type;
        that.Member_since = state.credentials.membership_date;
        that.email = state.credentials.email;
        that.mobile = state.credentials.mobile;
        that.tin = state.credentials.tin;
        that.age = state.credentials.age;
        that.birthdate = state.credentials.birthdate;
        that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
        that.username = state.credentials.username;
        that.registered = state.credentials.registered_date;
        that.qr = data.qr;
        that.currentTin = state.credentials.tin;
        that.express = data.express;
        that.deactivated = data.deactivated;
        const rawRegisteredDate = state.credentials.registered_date;
        if (rawRegisteredDate) {
          const parts = rawRegisteredDate.split('-');
          that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
        }

        const rawBirthdate = state.credentials.birthdate;
        if (rawBirthdate) {
          const parts = rawBirthdate.split('-');
          that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
        }

        that.checkUserFlow();
        that.setLoading(false);

      }).catch(function (error) {
        that.error = true;
        that.setLoading(false);
        that.show_message_modal = true;
        that.modal_message = error.response.data.message;
        if (error.response.status == 403) {
          that.expired = true
          that.modal_message = "Your session has expired. Please log in again.";
          that.$store.state.logged = false;
        }
      });
    },
    checkUserFlow() {
      const that = this;
      const state = that.$store.state;
      const noContact = !state.credentials.mobile || !state.credentials.email;
      const config = state.credentials.config;
      const temporaryPIN = state.credentials.pin_update;
      const isValidated = that.$cookies.get('validated');

      this.getEndpoints();

      if (state.credentials.deactivated) {
        this.$router.push('/user/settings');
        return;
      }

      if (noContact) {
        state.credentials.noContact = noContact;
        this.show_update = true;
        return;
      }

      if (state.credentials.enrolled_pin) {
        const hasValidConfig = config && config.status;
        const noContact = state.credentials.noContact;
        state.credentials.enrolled_pin = false;

        if (noContact) {
          that.show_update = false;
          that.show_pin_modal = false;
          that.show_otp_modal = false;
          that.$cookies.set('validated', true);
        } else {
          if (hasValidConfig) {
            that.requestOTP();
          } else {
            that.show_update = false;
            that.show_pin_modal = false;
            that.show_otp_modal = false;
            that.$cookies.set('validated', true);
          }
        }
        return;
      }


      if (!isValidated) {
        if (state.credentials.has_pin) {
          this.show_pin_modal = true;
        } else {
          this.$router.push('/user/settings');
        }
      }

      if (temporaryPIN) {
        this.$router.push('/user/settings');
        state.credentials.edit_temporary = true;
        return;
      }

      const missingInfo = !state.credentials.mobile || !state.credentials.email ||
        !state.credentials.tin || !state.credentials.birthdate;

      if (missingInfo && !that.$cookies.get('skipped')) {
        this.show_update = true;
      }
    },
  },
};
</script>

<style scoped>
.main-container {
  overflow: hidden;
  /* prevents whole page scroll */
}

.header {
  flex-shrink: 0;
  /* prevents header from shrinking */
}

.tab-container {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background: white;
}

.papsi-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.box {
  width: 4rem !important;
  height: 4rem !important;
  margin-right: 3rem !important;
}

.step-circle {
  background: #0a7508;
  color: white;
  transition: all 0.3s ease;
}

.step-circle.active {
  background: #b99400;
  /* primary */
  transform: scale(1.1);
}

.step-circle.completed {
  background: #025700;
  /* green */
}


.step-circle.completed+.step-line {
  background: #006b27;
}

@media (max-width: 1000px) {
  .box {
    width: 2rem !important;
    height: 2rem !important;
    margin-right: 1rem !important;
    font-size: 5rem !important;
  }

  .agree {
    font-size: 1.7rem !important;
  }


}
</style>